import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`;

export const Col = styled.div`
  ${({ md3 }) =>
    md3 &&
    css`
      @media (min-width: 768px) {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
      }
    `}
  ${({ md9 }) =>
    md9 &&
    css`
      @media (min-width: 768px) {
        -ms-flex: 0 0 75%;
        flex: 0 0 75%;
        max-width: 75%;
      }
    `}
  ${({ md12 }) =>
    md12 &&
    css`
      @media (min-width: 768px) {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
      }
    `}
`;
